"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgVolume(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M13.806 1.662l.007.107v20.463c0 .619-.686.969-1.182.646l-.085-.064-6.947-5.954H1.791c-.938 0-1.71-.725-1.785-1.644L0 15.07V8.93c0-.936.726-1.709 1.644-1.784l.147-.006h3.808l6.947-5.954a.768.768 0 011.26.476zm-1.528 1.775L6.382 8.49l-.01.01a.77.77 0 01-.074.053l.084-.063a.773.773 0 01-.395.178l-.104.007H1.791a.26.26 0 00-.25.198l-.006.058v6.139c0 .119.086.222.198.249l.058.007h4.092a.765.765 0 01.408.117l.021.014a.77.77 0 01.06.044l.01.01 5.896 5.052V3.437zm6.074.667C21.685 5.175 24 8.365 24 12c0 3.628-2.304 6.81-5.628 7.888a.767.767 0 01-.474-1.46c2.69-.873 4.567-3.464 4.567-6.428 0-2.97-1.886-5.568-4.583-6.435a.767.767 0 01.47-1.461zm-2.23 4.06a3.837 3.837 0 110 7.674.767.767 0 01-.104-1.529l.105-.007a2.302 2.302 0 100-4.604.767.767 0 110-1.534z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgVolume;
exports.default = _default;